"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLootShopCategoriesResponseToJSON = exports.GetLootShopCategoriesResponseFromJSONTyped = exports.GetLootShopCategoriesResponseFromJSON = void 0;
var _1 = require("./");
function GetLootShopCategoriesResponseFromJSON(json) {
    return GetLootShopCategoriesResponseFromJSONTyped(json, false);
}
exports.GetLootShopCategoriesResponseFromJSON = GetLootShopCategoriesResponseFromJSON;
function GetLootShopCategoriesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categories': (json['categories'].map(_1.MenuCategoryFromJSON)),
    };
}
exports.GetLootShopCategoriesResponseFromJSONTyped = GetLootShopCategoriesResponseFromJSONTyped;
function GetLootShopCategoriesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categories': (value.categories.map(_1.MenuCategoryToJSON)),
    };
}
exports.GetLootShopCategoriesResponseToJSON = GetLootShopCategoriesResponseToJSON;
